import {makePostBeneficiaryAddressV4} from 'main/factories/usecases';
import {formValuesToAddressV4Item} from '../utils/addressV4Payload';
import {PatchFavoriteAddressServiceParams} from '../types';

export async function patchFavoriteAddress({
	cdBeneficiarioEnderecoFavorito,
	sequence,
	data,
	existingLatLng,
	signal,
}: PatchFavoriteAddressServiceParams) {
	const latLng = existingLatLng ?? null;
	const addressItem = formValuesToAddressV4Item(data, latLng);
	addressItem.sequence = sequence ?? cdBeneficiarioEnderecoFavorito;

	await makePostBeneficiaryAddressV4().post({addresses: [addressItem], signal});
}
